export const roundToNearest = (value, nearestValue) => {
  return Math.round(value / nearestValue) * nearestValue;
};
